import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from '@/stores/user';

import Login from '@/pages/Login.vue';
import Sites from '@/pages/Sites.vue';
import SiteDetail from '@/pages/SiteDetail.vue';
import ConnectMyLaptop from '@/pages/ConnectMyLaptop.vue';
import CliTokens from '@/pages/CliTokens.vue';
import Approvals from '@/pages/Approvals.vue';
import ApprovalDetail from '@/pages/ApprovalDetail.vue';
import MyAccess from '@/pages/MyAccess.vue';

export const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', redirect: '/sites' },
        { path: '/login', component: Login, meta: { public: true } },
        { path: '/sites', component: Sites },
        { path: '/sites/:siteId', component: SiteDetail, props: true },
        { path: '/connect', component: ConnectMyLaptop },
        { path: '/access', component: MyAccess },
        { path: '/account/cli-tokens', component: CliTokens },
        { path: '/approvals', component: Approvals, meta: { requiresApprover: true } },
        { path: '/approvals/:grantId', component: ApprovalDetail, props: true, meta: { requiresApprover: true } },
    ],
});

router.beforeEach(async (to) => {
    const user = useUserStore();
    if (to.meta.public) return true;
    if (!user.loaded) await user.load();
    // Bounce unauthenticated users to /login, preserving where they were
    // heading (e.g. an email deep-link to /approvals/<grantId>) so the backend
    // can land them there after the OIDC round-trip.
    if (!user.identity) {
        const returnTo = to.fullPath && to.fullPath !== '/' ? to.fullPath : undefined;
        return returnTo ? { path: '/login', query: { returnTo } } : { path: '/login' };
    }
    // Approver-only routes: non-approvers are bounced to /sites.
    if (to.meta.requiresApprover && !user.identity.isApprover) return { path: '/sites' };
    return true;
});
